import { ThirdPartyBannerType } from 'corgi-types';

import type { IconName } from 'common/components/Icon';

interface BannerConfig {
  title: string;
  chevronSize: number;
  headingBottomMargin: Array<string | null> | string;
  moreInfoDrawer?: {
    title: string;
    content: string;
  };
  icon?: IconName;
  link?: string;
}

const reclamationSurveyBannerConfig: BannerConfig = {
  title: 'h24_reclamation_survey_title',
  chevronSize: 20,
  headingBottomMargin: 'sp_12',
  link: 'h24_reclamation_survey_link',
  icon: 'survey',
};

export const BANNER_CONFIGS = new Map<ThirdPartyBannerType, BannerConfig>([
  [ThirdPartyBannerType.ReclamationSurvey, reclamationSurveyBannerConfig],
]);
